module.exports = __webpack_public_path__ + "static/media/coworking_space.c1ec7cac.jpg";